import Phaser from 'phaser';
import { GAME_CONFIG } from '../config/gameConfig';

export default class Ball extends Phaser.Physics.Arcade.Sprite {
  private isStationary: boolean = true; // 静止状態かどうか

  constructor(scene: Phaser.Scene, x: number, y: number) {
    // 画像を使用してボールを作成
    super(scene, x, y, 'cat');
    
    scene.add.existing(this);
    scene.physics.add.existing(this);
    
    // 原点を中心に設定
    this.setOrigin(0.5, 0.5);
    
    // 画像をリサイズせずそのまま使用
    // 画像の実際のサイズを取得
    const displayW = this.displayWidth;
    const displayH = this.displayHeight;
    const r = GAME_CONFIG.physics.ballRadius; // コライダー半径は現状維持（40）
    
    console.log('Ball: 画像サイズ =', displayW, 'x', displayH, 'コライダー半径 =', r);
    
    const body = this.body as Phaser.Physics.Arcade.Body;
    
    // デバッグ用：設定前の値を確認
    console.log('Ball BEFORE setCircle - displaySize:', displayW, displayH, 'radius:', r, 'body.size:', body.width, body.height);
    
    // 円のコライダーを設定（半径20）
    body.setCircle(r);
    
    // デバッグ用：setCircle後の値を確認
    console.log('Ball AFTER setCircle - body.size:', body.width, body.height, 'body.radius:', body.radius);
    
    // 重要：setCircle()の後に物理ボディのサイズを画像のサイズに合わせる
    body.setSize(displayW, displayH);
    
    // 重要：setSize()を呼ぶとsetCircle()の設定がリセットされるため、再度setCircle()を呼ぶ
    body.setCircle(r);
    
    // 重要：コライダーのオフセットを画像の中心に合わせる
    body.setOffset(0, 0);
    
    // デバッグ用：最終的な値を確認
    console.log('Ball FINAL - body.size:', body.width, body.height, 'displaySize:', displayW, displayH, 'radius:', r, 'body.radius:', body.radius, 'body.offset:', body.offset.x, body.offset.y);
    
    // 物理ボディが有効であることを確認
    body.enable = true;
    // 画面端での跳ね返りは無効化（反対側から出現させるため）
    body.setCollideWorldBounds(false);
    body.setBounce(GAME_CONFIG.physics.ballBounce);
    
    // 初期速度を0に設定（静止状態で開始）
    body.setVelocity(0, 0);
    
    // 静止状態では重力を無効化
    body.setAllowGravity(false);
    
    this.setDepth(25); // 暗転オーバーレイ（15）より前、ライトエフェクト（20）より後ろ
  }


  /**
   * ボールを発光させる（得点時）
   * 現在は使用しない（周囲エフェクト削除のため）
   */
  glow(): void {
    // 周囲エフェクトを削除したため、何もしない
  }

  /**
   * ボールに初速を与える（次のリングの方向へ）
   */
  shoot(targetX: number, targetY: number): void {
    const dx = targetX - this.x;
    const dy = targetY - this.y;
    const distance = Math.sqrt(dx * dx + dy * dy);
    const speed = GAME_CONFIG.physics.ballJumpForce; // ballInitialSpeedは存在しないためballJumpForceを使用
    
    const body = this.body as Phaser.Physics.Arcade.Body;
    // 発射時は重力を有効化
    body.setAllowGravity(true);
    this.isStationary = false;
    
    this.setVelocity(
      (dx / distance) * speed,
      (dy / distance) * speed
    );
  }
  
  /**
   * ボールを静止状態にリセット
   */
  resetToStationary(x: number, y: number): void {
    const body = this.body as Phaser.Physics.Arcade.Body;
    body.setVelocity(0, 0);
    body.setAllowGravity(false);
    this.setPosition(x, y);
    this.isStationary = true;
    
    // 発光エフェクトは削除済み
  }
  
  /**
   * ボールが静止状態かどうかを取得
   */
  getIsStationary(): boolean {
    return this.isStationary;
  }
  
  /**
   * ボールの静止状態を設定
   */
  setIsStationary(value: boolean): void {
    this.isStationary = value;
  }

  update(): void {
    // 速度に基づいて画像を進行方向に回転
    const body = this.body as Phaser.Physics.Arcade.Body;
    const vx = body.velocity.x;
    const vy = body.velocity.y;
    
    // 速度が0でない場合、進行方向に回転
    if (vx !== 0 || vy !== 0) {
      // atan2で角度を計算（ラジアン）
      const angle = Math.atan2(vy, vx);
      this.setRotation(angle);
    }
  }

  destroy(): void {
    super.destroy();
  }
}

